/**
 * Created by ewald.stamp on 20.08.2014.
 */

angular.module('cfn').factory('Settings', function($resource) {
  return $resource(
    '/365FarmNet/rest/settings/settings',
    {},
    {
      save: { method: 'PUT' }
    }
  );
});
